import { useGetProductStockQuery } from "flows/Inventory/shared/queries/inventoryEntry/inventoryEntry.generated";

export function useProductStock(sku?: string | null) {
  const { data, loading } = useGetProductStockQuery({
    fetchPolicy: "network-only",
    variables: { sku: sku ?? "", isAlwaysInbound: true },
    skip: !sku,
  });

  const stock = data?.getProduct.inventoryEntry.stock?.shelf ?? 0;
  return { stock, loading };
}
